var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIc36(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "11.5359mm",
    height: "6.8611mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 11535.8 6861",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M1677.6 4953.6c3.9,49.1 6,98.8 6,148.3 0,396.6 -126.6,783.1 -360.7,1103.1 -302.9,316.1 -688,543.5 -1111.2,656.1l-211.7 -566.1c205.7,-72.2 397.8,-179.9 566.3,-317.6 124,-113.1 215.5,-257.6 264.5,-418 46.6,-185.4 70,-376.3 70,-567.6 0,-23.2 -0.6,-47.2 -1.1,-70l-0.1 -4823.3 777.9 0 0 4855.1 0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M6212.4 529.6c365.7,291 579.1,733.4 579.1,1200.8 0,40.7 -1.7,81.7 -4.9,122.2 2.9,40.1 4.5,80.3 4.5,120.6 0,488.1 -221.9,950 -602.6,1255.2 -429.3,294.7 -938.6,452.8 -1459.8,452.8 -42.2,0 -85.7,-1.3 -127.6,-3.1l-711.7 0.1 0 2071.7 -777.9 0 0 -5651.5 1481.7 0c58,-3.7 117.1,-5.9 175.3,-5.9 513.6,0 1016.7,152.2 1443.9,437l0 0.1zm-608.5 2254.3c238.1,-174.6 357.2,-486.8 357.2,-941.9 2.7,-30.9 4.1,-61.8 4.1,-92.7 0,-301.3 -132.2,-587.5 -361.3,-783.1 -269.3,-175.1 -584.2,-268.4 -905.5,-268.4 -37.7,0 -75.7,1.4 -113.2,3.9l-695.8 -0.1 0 2349.5 680 0c38.7,2.5 78.2,4 117.1,4 324.3,0 642.6,-91.5 917.5,-263.2l-0.1 -8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M10705.1 151.3c280.8,114.5 542.2,273.7 772.6,470.8l-457.7 476.3c-173.8,-147.1 -371,-266.5 -582.2,-351.9 -198.5,-71.7 -408.8,-108.6 -620,-108.6 -9.3,0 -19.1,0.2 -28.3,0.2 -1,0 -2,0 -3.1,0 -280.8,0 -555.5,81.8 -790.5,235.4 -267.6,183.2 -475.2,442.5 -595.3,743.6 -157.7,386 -239.1,800.3 -239.1,1217.4 0,25.2 0.4,51.5 0.8,76.3 0,793.8 129.6,1367.9 388.9,1735.7 248.8,345.1 648.4,549.9 1073.8,549.9 25.7,0 51.8,-0.8 77.4,-2.3 7.4,-0.1 15.8,0.2 23.7,0.2 361.5,0 717.5,-91.2 1034.4,-264.8l0.1 -1687.9 -986.9 0 -89.9 -629.7 1852 0 0 2725.2c-559.9,326.9 -1198.7,500 -1847.9,500 -1.3,0 -2.7,0 -4,0 -36.2,1.7 -73.4,2.8 -109.7,2.8 -626.3,0 -1222.1,-272.7 -1631.5,-746.4 -405.6,-497.3 -608.4,-1224.8 -608.4,-2182.6 -0.8,-33.7 -1.6,-68.7 -1.6,-102.9 0,-513.4 114.4,-1021.3 334.8,-1484.8 195,-411.3 505.5,-759.3 891.9,-1000 358,-211.3 766.8,-323.2 1182.8,-323.2 15.6,0 32.1,0.3 47.4,0.6 16.6,-0.3 33.7,-0.6 50.5,-0.6 294.9,0 587.9,51.3 865.1,151.2l-0.1 0.1z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc36);
export default __webpack_public_path__ + "static/media/ic_3_6.c9d736df355669946a44221ddcdbf384.svg";
export { ForwardRef as ReactComponent };